import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useComet, useMutation } from 'shared/api/hooks';
import { Box, LinearProgress, Typography } from '@mui/material';
import { OTBoilerStateTable } from './components/table';
import { useSwiperSlide } from 'swiper/react';
function useBoilerAdapterState(device_id, object_id) {
    //@ts-ignore
    const { isActive, isDuplicate } = useSwiperSlide();
    const [run, is_sending_request, , request_error, is_send_request] = useMutation('request_z3k_boiler_state', {
        device_id,
        object_id,
    });
    useEffect(() => {
        if (isActive && !isDuplicate) {
            if (!is_send_request) {
                run();
            }
        }
    }, [isActive, isDuplicate]);
    const [boiler_adapter_state, setBAState] = useState(null);
    const [error_got_ot_state, setErrorGotOtState] = useState(null);
    const onMessage = useCallback((message) => {
        if (message.ok) {
            setBAState(message.boiler_state);
        }
        else {
            setErrorGotOtState(message.error);
        }
    }, []);
    useComet({
        event: 'z3k_boiler_state',
        callback: onMessage,
        condition: { device_id, object_id },
    });
    return [
        is_sending_request,
        boiler_adapter_state,
        request_error ?? error_got_ot_state,
    ];
}
export const OTBoilerStateCard = memo(function OTBoilerStateCard(props) {
    const { device_id, boiler_adapter_id, last_boiler_adapter_state, boiler_type, not_available_ot_flags, boiler_model, } = props;
    const [is_sending_request, boiler_adapter_state, error] = useBoilerAdapterState(device_id, boiler_adapter_id);
    const { ot_state, status } = useMemo(() => {
        if (boiler_adapter_state) {
            const { ot: ot_state, status } = boiler_adapter_state;
            return {
                ot_state,
                status,
            };
        }
        return { ot_state: null, status: null };
    }, [boiler_adapter_state]);
    const no_connection = useMemo(() => {
        if (status?.no_adapter_connection) {
            return 'Нет связи с адаптером';
        }
        if (status?.no_boiler_connection) {
            return 'Нет связи с котлом';
        }
        if (status?.no_valid_params) {
            return 'Состояние адаптера еще не получено';
        }
        return null;
    }, [status]);
    const showed_ot_state = useMemo(() => no_connection
        ? last_boiler_adapter_state
        : ot_state ?? last_boiler_adapter_state, [ot_state, last_boiler_adapter_state, no_connection]);
    const is_loading = useMemo(() => is_sending_request || (ot_state == null && error == null), [is_sending_request, ot_state, error]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", p: 1, rowGap: 0.5, width: "100%", height: "calc(100% - 45px)", overflow: "auto", "data-tooltip": "ot-state-card", children: [_jsxs(Box, { display: "flex", flexDirection: "column", children: [error && (_jsx(Typography, { variant: "subtitle1", color: "error.main", children: error })), no_connection && (_jsx(Typography, { variant: "subtitle1", color: "error.main", children: no_connection })), is_loading && _jsx(LinearProgress, { color: "primary" }), ((last_boiler_adapter_state && ot_state == null) || no_connection) && (_jsx(Typography, { variant: "body2", color: "textSecondary", children: "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435" }))] }), showed_ot_state && (_jsx(OTBoilerStateTable, { ot_state: showed_ot_state, boiler_adapter_type: boiler_type, not_available_ot_flags: not_available_ot_flags, boiler_model: boiler_model, boiler_adapter_status: status }))] }));
});
